export enum StructureNodeType {
    CONCERN = 'concern',
    ORGANISATION = 'organisation',
    BUSINESSUNIT = 'businessunit',
    PROJECT = 'project'
}
